<template>
  <div id="App">
        <router-view />
      </div>
</template>
<script>


import $ from 'jquery'

export default {
  name: 'App',

     // `this` points to the vm instance


}
</script>



// WEBPACK FOOTER //
// src/App.vue